import React, { FC } from 'react';
import { ErrorSummary } from '@digdir/designsystemet-react';

interface Props {
  error?: Record<string, any>;
}

export const ErrorLinkItem: FC<Props> = ({ error }) => {
  if (!error) {
    return null;
  }

  return (
    <ErrorSummary.Item>
      <ErrorSummary.Link href={`#${error.ref.id}`}>{error.message}</ErrorSummary.Link>
    </ErrorSummary.Item>
  );
};
